$(document).ready(function () {
  if ($('.frame').data('page') == 'website_cost_estimator') {
    // estimatorBanner
    const estimatorBanner = gsap.timeline();
    estimatorBanner
      .from(".banner-estimator-img", { delay: 0.3, duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })

    let mm = gsap.matchMedia();
    mm.add("(max-width: 640px)", () => {
      // estimatorProcess
      let estimatorProcess_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#estimatorProcess",
          start: "top 40%",
        }
      });
      estimatorProcess_tl
        .from("#estimatorProcess .process-item:nth-child(1)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(2)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(3)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(4)", { duration: 0.5, y: -30, opacity: 0, ease: 'circ.out' })
    });

    mm.add("(min-width: 641px)", () => {
      // estimatorProcess
      let estimatorProcess_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#estimatorProcess",
          start: "top 40%",
        }
      });
      estimatorProcess_tl
        .from("#estimatorProcess .process-item:nth-child(1)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(2)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(3)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
        .from("#estimatorProcess .process-item:nth-child(4)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
    });


    // estimatorBoard
    let estimatorBoard_tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#estimatorBoard",
        start: "top 80%",
      }
    });
    estimatorBoard_tl
      .from(".feature-item:nth-child(1)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' })
      .from(".feature-item:nth-child(2)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
      .from(".feature-item:nth-child(3)", { duration: 0.5, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")

  }
});
